import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('AppButton').create(({ theme }) => ({
  gamedBtn: {
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    margin: 'none',
    padding: '0px',
    transition: 'all 0.24s linear',

    '&[data-variant="primary"]': {
      width: '100%',
      border: 'none',
      borderRadius: '12px',
      fontWeight: '400',
      fontSize: theme.sizes.texts.fontSize.l,
      lineHeight: theme.sizes.texts.lineHeight.xl,

      fontFamily: 'Space Grotesk',
      // padding: '8px 16px',
      background: theme.colors.button.primary.background,
      color: theme.colors.button.primary.text,

      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      gap: '2.69vw',
      '&:active': {
        background: `${theme.colors.button.primary.background}90`,
      },
      // '&:active::after': {
      //   content: '""',
      //   position: 'absolute',
      //   top: '0',
      //   left: '0',
      //   bottom: '0',
      //   right: '0',
      //   width: '100%',
      //   height: '100%',
      //   background: 'red',
      //   // zIndex: '0',
      // },
    },
    '&[data-variant="secondary"]': {
      width: '100%',
    },
    '&[data-variant="round"]': {
      borderRadius: '50%',
    },

    '&[data-variant="floating"]': {
      position: 'absolute',
      right: '2.5vh',
      bottom: '2.5vh',
      maxWidth: '69px',
      maxHeight: '69px',
      width: '100%',
      height: '100%',
      background:
        'radial-gradient(circle at center, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.075) 27.5%, transparent 69%)',
      '&:active': {
        background:
          'radial-gradient(circle at center, rgba(255, 255, 255, 0.07) 0%, rgba(255, 255, 255, 0.04) 27.5%, transparent 69%)',
      },
      color: '#FEFEFE',

      // animation: 'pulseAnimation 3s infinite linear',

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },

    '&[data-iconAnimation="rotation"]:active > img': {
      transform: 'rotate(60deg)',
      transition: 'all 0.24s linear',
    },
  },

  '@keyframes pulseAnimation': {
    '0%': {
      transform: 'scale(1)',
      opacity: 1,
    },
    '50%': {
      transform: 'scale(1.1)',
      opacity: '0.8',
    },
    '100%': {
      transform: 'scale(1)',
      opacity: '1',
    },
  },
}))
